// removed by extract-text-webpack-plugin
module.exports = {"firstCol":"index__firstCol___2sI8B","attachment-item":"index__attachment-item___1-BjQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/page/DetailsSubpanels/components/Subpanel/index.less
// module id = 1875
// module chunks = 3